import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { ResizableTable } from "../../../components/resizableTable/ResizableTable";

const ForecastMovedOutPaper = ({
  classes,
  isForecastMovedOutLoading,
  forecastMovedOutData,
  forecastMovedOutRows,
  forecastResizableColumns,
  forecastGetCellValue,
  handleOppRowClick,
  createSummaryTableColumns,
  currencySymbol,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Typography variant="h6" className={classes.title}>
            Sales Forecast – Current Quarter – Forecast – Most Likely + Commit
            Opps moved out in the last week
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>
        {isForecastMovedOutLoading ? (
          <Skeleton variant="rect" animation="wave" height={200} width="100%" />
        ) : (
          <>
            {/*
            {forecastMovedOutData?.movedOutOpps?.length > 0 && (
            <Box mb={3}>
              <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                Summary
              </Typography>
              <ResizableTable
                columns={createSummaryTableColumns(currencySymbol)}
                rows={[
                  {
                    label: "Moved Out Opps",
                    count: forecastMovedOutData?.summary?.movedOut?.count || forecastMovedOutData?.totalCount || 0,
                    acvInMillions: forecastMovedOutData?.summary?.movedOut?.acvInMillions || forecastMovedOutData?.totalACVInMillions || "0.00",
                    rowType: "movedOut",
                  },
                  {
                    label: "Forecast Goal (1.5x Quota)",
                    count: "",
                    acvInMillions: forecastMovedOutData?.summary?.forecastGoal || "0.00",
                    rowType: "forecast",
                  },
                  {
                    label: "Quota",
                    count: "",
                    acvInMillions: forecastMovedOutData?.summary?.quotaInMillions || forecastMovedOutData?.quotaInMillions || "0.00",
                    rowType: "quota",
                  },
                ]}
                getCellValue={(row, field) => {
                  if (field === "label") return row[field];
                  return row[field] != null ? row[field] : "";
                }}
                getCellStyle={(row, field) => {
                  const baseStyle = {};
                  if (field === "label") baseStyle.fontWeight = 600;
                  if (row.rowType === "movedOut") {
                    baseStyle.backgroundColor = "#f5f5f5";
                    if (field === "count" || field === "acvInMillions") baseStyle.fontWeight = 600;
                  }
                  if (row.rowType === "quota") {
                    baseStyle.backgroundColor = "#fff9c4";
                    if (field === "acvInMillions") baseStyle.fontWeight = 600;
                  }
                  return baseStyle;
                }}
                rowKey="label"
                hideSubHeaderRow={true}
                maxWidth="34%"
              />
            </Box>
            )}
            */}

            {/* Moved Out Opps Table */}
            <Box mb={3}>
              {/* <Typography
                variant="subtitle1"
                style={{ fontWeight: 600, marginTop: 70 }}
              >
                Opportunities Moved Out of Forecast (Most Likely + Commit)
              </Typography> */}
              {!forecastMovedOutData?.movedOutOpps ||
              forecastMovedOutData.movedOutOpps.length === 0 ? (
                <Box
                  textAlign="center"
                  py={4}
                  style={{ fontStyle: "italic", color: "#666" }}
                >
                  No forecast opps moved out this week
                </Box>
              ) : (
                <ResizableTable
                  columns={forecastResizableColumns}
                  rows={forecastMovedOutRows || forecastMovedOutData.movedOutOpps}
                  getCellValue={forecastGetCellValue}
                  getCellStyle={(row) => row.isTotalRow ? { fontWeight: 700, backgroundColor: "#f5f5f5" } : {}}
                  rowKey="Opp_ID"
                  hideSubHeaderRow={true}
                  maxWidth="100%"
                  onRowClick={handleOppRowClick}
                />
              )}
            </Box>
          </>
        )}
      </Paper>
    </Grid>
  );
};

export default ForecastMovedOutPaper;
